import Entity from '../entity'

export default class Recruit extends Entity<number> {
    postName: string = "";
    responsibility: string = "";
    requirement: string = "";
    salary: string = "";
    jobAddress: string = "";
    company: string = "";
    profile: string = '';
    linkMan: string = "";
    telPhone: string = "";
    address: string = "";
    creationTime: Date;
    creatorUserId: number = 0;
}